var map = {
	"./amazon.png": "9320",
	"./american-express.png": "23c9",
	"./btc.png": "b699",
	"./citi.png": "97dd",
	"./default.svg": "dc6a",
	"./discover.png": "585b",
	"./master.png": "6875",
	"./paypal.png": "e8af",
	"./stripe.png": "f78a",
	"./visa.png": "1d74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b6d";